import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import DataTable from "../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { getUnitwiseViewColumns } from "./UnitWiseOccData";

import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../../../../Redux/slice/features/paginationSilce";
import { REACT_APP_API_URL } from "../../../../../env";

const HotelBookingDetails = () => {
  const { P_HotelID, checkinDate } = useParams();
  console.log("checkinDate", checkinDate);
  const [hotelName, setHotelName] = useState("Hotel");
  const [dataT, setDataT] = useState([]);

  const currentPage = useSelector((state) => state.pagination.currentPage);
  const itemsPerPage = useSelector((state) => state.pagination.itemsPerPage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setCurrentPage(1));
  }, [dispatch]);

  useEffect(() => {
    const fetchHotelName = async () => {
      try {
        const res = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/hotel-name/${P_HotelID}`
         
        );
        setHotelName(res.data?.PropertyName || "Hotel");
      } catch (error) {
        console.error("Error fetching hotel name:", error);
        setHotelName("Hotel");
      }
    };

    const fetchBookingDetails = async () => {
      try {
        const res = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/booking-details/${P_HotelID}/${checkinDate}`
           
        );
        const bookings = res.data.data || [];

        const filtered = bookings.filter(
          (item) =>
            new Date(item.CheckinDate).toDateString() ===
            new Date(checkinDate).toDateString()
        );

        const formatted = filtered.map((item, index) => ({
          Sl: index + 1,
          CustomerName: item.CustomerName,
          CustomerMobile: item.MobileNo,
          RoomType: item.RoomType,
          BookingDateTime: item.BillDate || "",
          CheckinDate: item.CheckinDate || "",
          CheckoutDate: item.CheckOutDate || "",
          BookingRefNo: item.BookingRefNo,
          BookingID: item.BookingID,
          NoOfRooms: item.TotalNoOfRoom,
          TotalAmount: `₹ ${item.TotalAmount?.toFixed(2)}`,
          BookedBy: item.PropertyName || "-",
          EmailID: item.EmailID || "-",
        }));

        setDataT(formatted);
      } catch (error) {
        console.error("Error fetching booking details:", error);
        setDataT([]);
      }
    };

    fetchHotelName();
    fetchBookingDetails();
  }, [P_HotelID, checkinDate]);

  const totalPages = Math.ceil(dataT.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

 const handleBookingClick = (row) => {
  if (row?.BookingID) {
    window.open(`/booking-view/${row.BookingID}`, "_blank");
  }
};

  const columns = useMemo(
    () => getUnitwiseViewColumns(handleBookingClick),
    [handleBookingClick]
  );

  const currentItems = useMemo(() => {
    return dataT.slice(indexOfFirstItem, indexOfLastItem);
  }, [dataT, indexOfFirstItem, indexOfLastItem]);

  const handleNextPage = useCallback(() => {
    if (currentPage < totalPages) {
      dispatch(setCurrentPage(currentPage + 1));
    }
  }, [currentPage, totalPages, dispatch]);

  const handlePreviousPage = useCallback(() => {
    if (currentPage > 1) {
      dispatch(setCurrentPage(currentPage - 1));
    }
  }, [currentPage, dispatch]);

  return (
    <div className="p-4 bg-white rounded shadow">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl text-center font-semibold ">
          Hotel Booking Details
        </h2>
      </div>

      <div className="mb-4">
        <p className="h6 fw-bold mb-0 text-danger">{hotelName}</p>
      </div>

      <DataTableHeader columns={columns} data={dataT} />
      <DataTable columns={columns} data={currentItems} enablePagination={false} />
      <DataTableFooter
        dataT={dataT}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
      />
    </div>
  );
};

export default React.memo(HotelBookingDetails);
